module.exports = {
    RECEIVE_ALL_USAGE: 'RECEIVE_ALL_USAGE',
    RECEIVE_USAGE: 'RECEIVE_USAGE',
    USAGES: 'USAGES',
    RESET_USAGE: 'RESET_USAGE',
}
